import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' // global css

import echarts from 'echarts'

import ElementUI from 'element-ui';
ElementUI.Dialog.props.closeOnClickModal.default = false

// 引入全局css样式
import "assets/css/base.css";
import "assets/css/index.css";

import { message } from './utils/resetMessage'
Vue.use(ElementUI)
Vue.prototype.$message = message;

// 引入 element-ui,闭包执行
import '@/plugins/element-ui.js'

// 日期插件
import moment from 'moment'


/* Vue.use(require('vue-moment'));
Vue.prototype.moment = moment */

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI)

// 设置开发状态，使用mock模拟后端数据
// if (process.env.NODE_ENV === 'development') require('api/mock')

new Vue({
  router,
  store,
  data: function(){
          // 全局变量
          // 调用 this.$root.isActiveApp
          // 赋值 this.$root.colorController = !this.$root.colorController
          return {
              isActiveApp: true,
              //colorController: 'black',
              colorController: '#000',
              
          }
      },
  render: h => h(App)
}).$mount('#app')

// 禁止输入特殊字符
Vue.prototype.validForbid = function (value, number = 255) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
}

// 全局格式化日期方法YYYY-MM-DD HH:mm:ss
Vue.filter('dateYMDHMSFormat',function(dateStr,pattern='YYYY-MM-DD HH:mm:ss'){
  return moment(dateStr).format(pattern);
})

// 全局格式化日期方法YYYY-MM-DD
Vue.filter('dateYMDHFormat',function(dateStr,pattern='YYYY-MM-DD'){
  return moment(dateStr).format(pattern);
})

import BaiduMap from "vue-baidu-map"
Vue.use(BaiduMap,{
    ak:'c285EvoFwodyUsTDY4sGiGV1'
})
